import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface FeatureToggleState {
  enabledFeatures: Record<string, boolean>;
  loading: boolean;
  error: string | null;
}

const initialState: FeatureToggleState = {
  enabledFeatures: {},
  loading: false,
  error: null,
};

const featureToggleSlice = createSlice({
  name: 'featureToggle',
  initialState,
  reducers: {
    setFeatureEnabled: (state, action: PayloadAction<{ feature: string; enabled: boolean }>) => {
      state.enabledFeatures[action.payload.feature] = action.payload.enabled;
    },
    setFeatures: (state, action: PayloadAction<Record<string, boolean>>) => {
      state.enabledFeatures = action.payload;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
  },
});

export const { setFeatureEnabled, setFeatures, setLoading, setError } = featureToggleSlice.actions;
export default featureToggleSlice.reducer;
